import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { Tag } from "../../../definitions/tag";
import { MpCommonActions } from "../../actions/mp-common.actions";
import { TagsState } from "../../models/mp-common/tags-state";

const initialState: TagsState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpCommonActions.tags.getApi, (state) => _.set(_.cloneDeep(state), "loading", true)),
	on(MpCommonActions.tags.getSuccess, (state, { tags, loading }) => ({
		...state,
		tags,
		loading,
		error: null
	})),
	on(MpCommonActions.tags.createSuccess, (state, tag) => addTagToState(state, tag)),
	on(MpCommonActions.tags.updateSuccess, (state, tag) => updateState(state, tag)),
	on(MpCommonActions.tags.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	)
);

function updateState(state: TagsState, tag: Tag) {
	return {
		...state,
		tags: state.tags.map((item) => (item.id === tag.id ? { ...item, name: tag.name } : item))
	};
}

function addTagToState(state: TagsState, tag: Tag) {
	return {
		...state,
		tags: [...state.tags, tag]
	};
}

export function tagsReducer(state: TagsState, action: Action): TagsState {
	return reducer(state, action);
}
